module.exports = __webpack_public_path__ + "static/media/gts03.a0d93b3b.png";